import * as React from "react";
import IVendorModel from "../models/IVendorModel";

const VendorContext = React.createContext<IVendorModel>({} as IVendorModel);

export default VendorContext;
